import { toPost } from "../../../../../../../../common/apis/http-utils";

export const getIcon = toPost<{ version: number }, any>(`/merchant/meeting/getIcon`);